import { RoomModel } from '../../common/models/RoomModel.js'
import { BookingModel } from '../../common/models/BookingModel.js'
import { roundMinutesToNearest5Or0 } from '../../common/utils/utils.js'

export interface TimeSlot {
    startTime: Date;
    endTime: Date;
    displayTime: string;
}

/**
 * Generate time slots for the day from current hour to end of day
 */
export function generateTimeSlots(): TimeSlot[] {
    const now = new Date()
    const currentHour = now.getHours()
    const slots: TimeSlot[] = []

    // Generate slots every 30 minutes
    for (let hour = currentHour; hour < 24; hour++) {
        for (const minute of [0, 30]) {
            const time = new Date()
            time.setHours(hour, minute, 0, 0)

            // Create a new end time 30 minutes later
            const endTime = new Date(time.getTime() + 30 * 60 * 1000)

            slots.push({
                startTime: time,
                endTime,
                displayTime: time.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
            })
        }
    }

    return slots
}

/**
 * Check if a time slot is selected
 */
export function isTimeSelected(selectedTime: Date | null, time: Date): boolean {
    return selectedTime?.toISOString() === time.toISOString()
}

/**
 * Get events between two time points
 */
export function getEventsBetween(room: RoomModel, startTime: Date, endTime: Date): BookingModel[] {
    return room.events.filter(event => {
        return (
            (event.startTime >= startTime && event.startTime < endTime) ||
            (event.endTime > startTime && event.endTime <= endTime) ||
            (event.startTime <= startTime && event.endTime >= endTime)
        )
    })
}

/**
 * Book a room with the API
 */
export async function bookRoom(
    roomId: string,
    startDateTime: Date,
    duration: number,
    description: string = 'Booked from calendar',
): Promise<Response> {
    // Calculate raw end time
    const rawEndDateTime = new Date(startDateTime.getTime() + duration * 60 * 1000)
    const endDateTime = roundMinutesToNearest5Or0(rawEndDateTime)
    const updatedDuration = Math.round((endDateTime.getTime() - startDateTime.getTime()) / (60 * 1000))

    return fetch('/api/v1/rooms/book', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            roomId,
            duration: updatedDuration,
            summary: `TimeHub booking (${updatedDuration} min)`,
            description,
            startDateTime: startDateTime.toISOString(),
            endDateTime: endDateTime.toISOString(),
        }),
    })
}
